import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import Navbar from './Navbar';
import Footer from './Footer';

const Bulkorder = () => {
  const [open, setOpen] = useState(false);
  
  // State for form data
  const [formData, setFormData] = useState({
    email: '',
    full_name: '',
    firm_name: '',
    mobile: '',
    monthly_sales: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  useEffect(() => {
    /**=====================
            Quantity 2 js
        ==========================**/
    $('.addcart-button').click(function () {
      $(this).next().addClass('open');
      $('.add-to-cart-box .qty-input').val('1');
    });

    $('.qty-left-minus').on('click', function () {
      var $qty = $(this).siblings('.qty-input');
      var _val = $($qty).val();
      if (_val === '1') {
        var _removeCls = $(this).parents('.cart_qty');
        $(_removeCls).removeClass('open');
      }
      var currentVal = parseInt($qty.val());
      if (!isNaN(currentVal) && currentVal > 0) {
        $qty.val(currentVal - 1);
      }
    });

    $('.qty-right-plus').click(function () {
      if ($(this).prev().val() < 9) {
        $(this)
          .prev()
          .val(+$(this).prev().val() + 1);
      }
    });
  }, []);

  const products = [
    {
      id: 1,
      title: 'Evercore Collagen Protein',
      img: '/assets/images/Collagen.png',
      unit: '300 G',
      priceNew: '₹2499',
      priceOld: '₹2899',
      link: '/Productdetails',
    },
    {
      id: 2,
      title: 'Evercore Yeast Protein',
      img: '/assets/images/Yeast_Protein.png',
      unit: '1 KG',
      priceNew: '₹2299',
      priceOld: '₹2999',
      link: '/Productdetails',
    },
  ];

  const getAuthToken = () => {
    // Try to get token from localStorage
    const token = localStorage.getItem('authToken');
    if (token) {
      return token;
    }
    
    // If not found, check if it's stored with a different key
    const possibleKeys = ['token', 'accessToken', 'access_token', 'userToken'];
    for (const key of possibleKeys) {
      const storedToken = localStorage.getItem(key);
      if (storedToken) {
        return storedToken;
      }
    }
    
    return null;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.email || !formData.full_name || !formData.mobile || !formData.monthly_sales) {
      setSubmitStatus({ 
        type: 'error', 
        message: 'Please fill in all required fields' 
      });
      return;
    }

    // Check for authentication token
    const token = getAuthToken();
    if (!token) {
      setSubmitStatus({ 
        type: 'error', 
        message: 'Authentication required. Please log in first.' 
      });
      return;
    }

    setLoading(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://evercorenutrition.com/ev_admin/api/bulk-order/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          email: formData.email,
          mobile: formData.mobile,
          full_name: formData.full_name,
          monthly_sales: formData.monthly_sales
        })
      });

      const data = await response.json();

      if (response.status === 401) {
        // Unauthorized - token might be expired
        setSubmitStatus({ 
          type: 'error', 
          message: 'Session expired. Please log in again.' 
        });
        
        // Optionally clear the invalid token
        localStorage.removeItem('authToken');
        
      } else if (response.ok && data.success) {
        setSubmitStatus({ 
          type: 'success', 
          message: data.message || 'Bulk order request submitted successfully!' 
        });
        
        // Clear form after successful submission
        setFormData({
          email: '',
          full_name: '',
          firm_name: '',
          mobile: '',
          monthly_sales: ''
        });

        // Close modal after 2 seconds
        setTimeout(() => {
          setOpen(false);
          setSubmitStatus({ type: '', message: '' });
        }, 2000);
      } else {
        setSubmitStatus({ 
          type: 'error', 
          message: data.message || 'Failed to submit. Please try again.' 
        });
      }
    } catch (error) {
      console.error('API Error:', error);
      setSubmitStatus({ 
        type: 'error', 
        message: 'Network error. Please check your connection.' 
      });
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setOpen(false);
    setFormData({
      email: '',
      full_name: '',
      firm_name: '',
      mobile: '',
      monthly_sales: ''
    });
    setSubmitStatus({ type: '', message: '' });
  };

  return (
    <>
      <Navbar />

      {/* Home Section Start */}
      <section className="home-section-2 home-section-bg pt-0 overflow-hidden">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-12">
              <div className="slider-animate">
                <div>
                  <div className="hero-banner-wrapper rounded-0 p-0">
                    <picture>
                      <source
                        media="(max-width: 768px)"
                        srcSet="assets/images/collagen.png"
                      />
                      <img
                        src="assets/images/bulkorderbanner.png"
                        className="hero-banner-image"
                        alt="Banner"
                        style={{ marginTop: '100px' }}
                      />
                    </picture>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Home Section End */}
      
      <section className="fresh-vegetable-section section-lg-space" style={{background:"#f6f6f6"}}>
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-6 col-12">
              <div className="row g-sm-4 g-2">
                <div className="col-12">
                  <div className="fresh-image-2 p-5">
                    <div>
                      <img
                        src="assets/images/new-images/Yeast Protein Double chocolate Monocarton-1.png"
                        alt="Fresh Image"
                        className="resimg"
                        style={{
                          maxWidth: '70%',
                          border: ' 1px solid #E0DDDC ',
                          borderRadius: '20px',
                          padding: "10px",
                          background: "#e4e4e4",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-12">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="review-title">
                    <h2>Join Us & Grow Your Business</h2>
                  </div>

                  <div className="delivery-list">
                    <h3>Become a trusted partner and enjoy exclusive benefits.</h3>
                    <ul className="delivery-box">
                      <li>
                        <div className="delivery-box">
                          <div className="delivery-icon">
                            <img
                              src="../assets/svg/3/delivery.svg"
                              className="blur-up lazyload"
                              alt="img"
                            />
                          </div>

                          <div className="delivery-detail">
                            <h5 className="text">Buy at Wholesale rates</h5>
                          </div>
                        </div>
                      </li>

                      <li>
                        <div className="delivery-box">
                          <div className="delivery-icon">
                            <img
                              src="../assets/svg/3/leaf.svg"
                              className="blur-up lazyload"
                              alt="img"
                            />
                          </div>

                          <div className="delivery-detail">
                            <h5 className="text">Genuine products directly from Company</h5>
                          </div>
                        </div>
                      </li>

                      <li>
                        <div className="delivery-box">
                          <div className="delivery-icon">
                            <img
                              src="../assets/svg/3/delivery.svg"
                              className="blur-up lazyload"
                              alt="img"
                            />
                          </div>

                          <div className="delivery-detail">
                            <h5 className="text">Start as low as Rs. 56,000</h5>
                          </div>
                        </div>
                      </li>

                      <li>
                        <div className="delivery-box">
                          <div className="delivery-icon">
                            <img
                              src="../assets/svg/3/leaf.svg"
                              className="blur-up lazyload"
                              alt="img"
                            />
                          </div>

                          <div className="delivery-detail">
                            <h5 className="text">Huge savings at Checkout</h5>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <h3 style={{ marginTop: '20px' }}>
                      Click the buttons below to fill up the form, and our team will reach out to
                      you soon.
                    </h3>
                    <div style={{ display: 'flex', margin: '20px 0px' }}>
                      <button
                        className="pro-acc-logout-btn text-white btn-sm mend-auto"
                        onClick={() => setOpen(true)}
                      >
                        Retailer <i className="fa-solid fa-arrow-right icon"></i>
                      </button>

                      {/* Backdrop and Modal */}
                      {open && (
                        <div
                          className="custom-modal-backdrop"
                          onClick={closeModal}
                          style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999,
                            backdropFilter: 'blur(4px)'
                          }}
                        >
                          {/* MODAL */}
                          <div
                            className="custom-modal"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              backgroundColor: 'white',
                              borderRadius: '12px',
                              width: '90%',
                              maxWidth: '500px',
                              maxHeight: '90vh',
                              overflow: 'auto',
                              position: 'relative',
                              boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                              animation: 'modalFadeIn 0.3s ease'
                            }}
                          >
                            <div className="modal-header" style={{
                              padding: '20px 24px',
                              borderBottom: '1px solid #eee',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              position: 'sticky',
                              top: 0,
                              backgroundColor: 'white',
                              zIndex: 10,
                              borderTopLeftRadius: '12px',
                              borderTopRightRadius: '12px'
                            }}>
                              <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600' }}>Retailer Form</h2>
                              <span
                                className="close-btn"
                                onClick={closeModal}
                                style={{
                                  fontSize: '28px',
                                  cursor: 'pointer',
                                  color: '#666',
                                  width: '32px',
                                  height: '32px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: '50%',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: '#f0f0f0'
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = '#e0e0e0';
                                  e.target.style.color = '#333';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.backgroundColor = '#f0f0f0';
                                  e.target.style.color = '#666';
                                }}
                              >
                                ×
                              </span>
                            </div>

                            <div className="modal-body" style={{ padding: '24px' }}>
                              {submitStatus.message && (
                                <div style={{
                                  padding: '12px 16px',
                                  marginBottom: '20px',
                                  borderRadius: '8px',
                                  backgroundColor: submitStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                                  color: submitStatus.type === 'success' ? '#155724' : '#721c24',
                                  border: `1px solid ${submitStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                                  fontSize: '14px'
                                }}>
                                  {submitStatus.message}
                                </div>
                              )}
                              
                              <form className="modal-form" onSubmit={handleSubmit}>
                                <div style={{ marginBottom: '16px' }}>
                                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                                    Email <span style={{ color: '#dc3545' }}>*</span>
                                  </label>
                                  <input 
                                    type="email" 
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required 
                                    style={{
                                      width: '100%',
                                      padding: '10px 12px',
                                      border: '1px solid #ddd',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      outline: 'none',
                                      transition: 'border-color 0.2s'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#0d6efd'}
                                    onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                  />
                                </div>

                                <div style={{ marginBottom: '16px' }}>
                                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                                    Full Name <span style={{ color: '#dc3545' }}>*</span>
                                  </label>
                                  <input 
                                    type="text" 
                                    name="full_name"
                                    value={formData.full_name}
                                    onChange={handleInputChange}
                                    required 
                                    style={{
                                      width: '100%',
                                      padding: '10px 12px',
                                      border: '1px solid #ddd',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      outline: 'none',
                                      transition: 'border-color 0.2s'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#0d6efd'}
                                    onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                  />
                                </div>

                                <div style={{ marginBottom: '16px' }}>
                                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                                    Firm Name
                                  </label>
                                  <input 
                                    type="text" 
                                    name="firm_name"
                                    value={formData.firm_name}
                                    onChange={handleInputChange}
                                    style={{
                                      width: '100%',
                                      padding: '10px 12px',
                                      border: '1px solid #ddd',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      outline: 'none',
                                      transition: 'border-color 0.2s'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#0d6efd'}
                                    onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                  />
                                </div>

                                <div style={{ marginBottom: '16px' }}>
                                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                                    Mobile Number <span style={{ color: '#dc3545' }}>*</span>
                                  </label>
                                  <input 
                                    type="tel" 
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={handleInputChange}
                                    maxLength="11"
                                    required 
                                    style={{
                                      width: '100%',
                                      padding: '10px 12px',
                                      border: '1px solid #ddd',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      outline: 'none',
                                      transition: 'border-color 0.2s'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#0d6efd'}
                                    onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                  />
                                </div>

                                <div style={{ marginBottom: '24px' }}>
                                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                                    Monthly Sales (in ₹) <span style={{ color: '#dc3545' }}>*</span>
                                  </label>
                                  <input 
                                    type="text" 
                                    name="monthly_sales"
                                    value={formData.monthly_sales}
                                    onChange={handleInputChange}
                                    placeholder="e.g., 12000"
                                    required 
                                    style={{
                                      width: '100%',
                                      padding: '10px 12px',
                                      border: '1px solid #ddd',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      outline: 'none',
                                      transition: 'border-color 0.2s'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#0d6efd'}
                                    onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                  />
                                </div>

                                <button 
                                  type="submit" 
                                  className="submit-btn"
                                  disabled={loading}
                                  style={{
                                    width: '100%',
                                    padding: '12px',
                                    backgroundColor: '#000000',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    opacity: loading ? 0.7 : 1,
                                    transition: 'background-color 0.2s'
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!loading) e.target.style.backgroundColor = '#000000';
                                  }}
                                  onMouseLeave={(e) => {
                                    if (!loading) e.target.style.backgroundColor = '#000000';
                                  }}
                                >
                                  {loading ? (
                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                      Submitting...
                                    </span>
                                  ) : 'Submit'}
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* Quick View Modal Box Start */}
      <div className="modal fade theme-modal view-modal" id="view" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-xl modal-fullscreen-sm-down">
          <div className="modal-content">
            <div className="modal-header p-0">
              <button type="button" className="btn-close" data-bs-dismiss="modal">
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-sm-4 g-2">
                <div className="col-lg-6">
                  <div className="slider-image">
                    <img
                      src="/assets/images/product1.webp"
                      className="img-fluid blur-up lazyload"
                      alt="img"
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="right-sidebar-modal">
                    <h4 className="title-name">Evercore Yeast Protein - Double Chocolate </h4>
                    <h4 className="price">₹ 1250.00</h4>
                    <div className="product-rating">
                      <ul className="rating">
                        <li><i data-feather="star" className="fill"></i></li>
                        <li><i data-feather="star" className="fill"></i></li>
                        <li><i data-feather="star" className="fill"></i></li>
                        <li><i data-feather="star" className="fill"></i></li>
                        <li><i data-feather="star"></i></li>
                      </ul>
                      <span className="ms-2">8 Reviews</span>
                      <span className="ms-2 text-danger">6 sold in last 16 hours</span>
                    </div>

                    <div className="product-detail">
                      <h4>Product Details :</h4>
                      <p>
                        Candy canes sugar plum tart cotton candy chupa chups sugar plum chocolate I
                        love. Caramels marshmallow icing dessert candy canes I love soufflé I love
                        toffee. Marshmallow pie sweet sweet roll sesame snaps tiramisu jelly bear
                        claw. Bonbon muffin I love carrot cake sugar plum dessert bonbon.
                      </p>
                    </div>

                    <ul className="brand-list">
                      <li>
                        <div className="brand-box">
                          <h5>Brand Name:</h5>
                          <h6>Black Forest</h6>
                        </div>
                      </li>
                      <li>
                        <div className="brand-box">
                          <h5>Product Code:</h5>
                          <h6>W0690034</h6>
                        </div>
                      </li>
                      <li>
                        <div className="brand-box">
                          <h5>Product Type:</h5>
                          <h6>White Cream Cake</h6>
                        </div>
                      </li>
                    </ul>

                    <div className="select-size">
                      <h4> Protein size:</h4>
                      <select className="form-select select-form-size">
                        <option value="">Select Size</option>
                        <option value="1.2">1/2 KG</option>
                        <option value="0">1 KG</option>
                        <option value="1.5">1/5 KG</option>
                      </select>
                    </div>

                    <div className="modal-button">
                      <a href="/cart" className="btn btn-md pro-acc-logout-btn icon">
                        Add To Cart
                      </a>
                      <a href="" className="btn pro-acc-logout-btn view-button icon text-white fw-bold btn-md">
                        View More Details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Quick View Modal Box End */}

      {/* Add animation styles */}
      <style jsx>{`
        @keyframes modalFadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </>
  );
};

export default Bulkorder;